import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { getPublicAgency } from './api';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [agency, setAgency] = useState<{ name: string | null; logo_url: string | null }>({ name: null, logo_url: null });
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    getPublicAgency().then(r => setAgency(r.data)).catch(() => {});
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError('');
    try {
      await login(username, password);
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Identifiants incorrects');
    } finally {
      setLoading(false);
    }
  };

  const showLogo = agency.logo_url && !logoError;

  return (
    <div style={{
      minHeight: '100vh', background: '#f8fafc',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Segoe UI', system-ui, sans-serif", padding: 24,
    }}>
      <div style={{
        width: '100%', maxWidth: 400,
        background: '#fff', border: '1px solid #e2e8f0',
        borderRadius: 20, padding: '48px 40px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          {showLogo ? (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
              <div style={{ width: 72, height: 72, borderRadius: 18, background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', border: '1px solid #e2e8f0' }}>
                <img
                  src={agency.logo_url!}
                  alt={agency.name || 'Logo'}
                  style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 8 }}
                  onError={() => setLogoError(true)}
                />
              </div>
              <div>
                <div style={{ color: '#0f172a', fontSize: 22, fontWeight: 800, letterSpacing: -0.5 }}>
                  {agency.name || 'NS Live'}
                </div>
                <div style={{ color: '#94a3b8', fontSize: 14, marginTop: 4 }}>
                  Panneau d'administration
                </div>
              </div>
            </div>
          ) : (
            <>
              <div style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 56, height: 56, borderRadius: 16,
                background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
                marginBottom: 16, boxShadow: '0 4px 20px rgba(124,58,237,0.2)',
              }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                    stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div style={{ color: '#0f172a', fontSize: 24, fontWeight: 800, letterSpacing: -0.5 }}>
                {agency.name || 'NS Live'}
              </div>
              <div style={{ color: '#94a3b8', fontSize: 14, marginTop: 4 }}>
                Panneau d'administration
              </div>
            </>
          )}
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ color: '#64748b', fontSize: 12, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>
              Identifiant
            </label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              placeholder="@tiktok, email ou identifiant"
              style={{
                display: 'block', width: '100%', marginTop: 6,
                padding: '12px 14px', borderRadius: 10,
                border: '1px solid #e2e8f0', background: '#f8fafc',
                color: '#0f172a', fontSize: 15, outline: 'none',
                boxSizing: 'border-box', transition: 'border-color 0.2s',
              }}
              onFocus={e => { e.target.style.borderColor = '#7c3aed'; e.target.style.background = '#fff'; }}
              onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
            />
          </div>

          <div>
            <label style={{ color: '#64748b', fontSize: 12, fontWeight: 600, letterSpacing: 0.5, textTransform: 'uppercase' }}>
              Mot de passe
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              style={{
                display: 'block', width: '100%', marginTop: 6,
                padding: '12px 14px', borderRadius: 10,
                border: '1px solid #e2e8f0', background: '#f8fafc',
                color: '#0f172a', fontSize: 15, outline: 'none',
                boxSizing: 'border-box', transition: 'border-color 0.2s',
              }}
              onFocus={e => { e.target.style.borderColor = '#7c3aed'; e.target.style.background = '#fff'; }}
              onBlur={e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
            />
          </div>

          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca',
              borderRadius: 8, padding: '10px 14px',
              color: '#dc2626', fontSize: 13,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !username || !password}
            style={{
              marginTop: 8, padding: '13px', borderRadius: 10, border: 'none',
              background: loading || !username || !password
                ? '#ede9fe'
                : 'linear-gradient(135deg, #7c3aed, #9333ea)',
              color: loading || !username || !password ? '#a78bfa' : '#fff',
              fontSize: 15, fontWeight: 600,
              cursor: loading || !username || !password ? 'not-allowed' : 'pointer',
              transition: 'opacity 0.2s, transform 0.1s',
              boxShadow: loading || !username || !password ? 'none' : '0 4px 16px rgba(124,58,237,0.25)',
            }}
            onMouseDown={e => { if (!loading) (e.currentTarget.style.transform = 'scale(0.98)'); }}
            onMouseUp={e => { (e.currentTarget.style.transform = 'scale(1)'); }}
          >
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
